module.exports = __webpack_public_path__ + "static/How-to-Install-3-e1403552781677-1e360f69696ebc9df4ac7f0694950476.jpg";